import './footer.css';

function Footer() {
  return (
    <footer>
      <div className='bodyContainer text-center'>
        &copy; Ayrat Gimranov, Alex Payne, Connor Boyce 2021-2022
      </div>
    </footer>

  )
}

export default Footer